module.exports = __webpack_public_path__ + "img/audio-2.3f7a3ce8.jpg";